import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthContextProvider from '../src/Context/auth/authProvider';
import PrivateRouter from './Utils/PrivateRouter';
import PrivateRoutes from './Routes/Routes';
import MainLayout from './Layout/MainLayout';
import AuthLoginPage from './AuthPages/AuthLoginPage';
import Error404Page from './Pages/Error404Page';
import { connect } from 'react-redux';
import SuspenseLoader from './Utils/SuspenseLoader';
import { PrimeReactProvider } from 'primereact/api';
import navigation from "./menu-items";


function App(props) {
  const { isAuthorised, authToken } = props;

  // Function to check token validity
  const isTokenValid = () => {
    if (!authToken) return false;
    const expiryDate = new Date(authToken); // authtoken saved as date string in redux
    return expiryDate > new Date();
  };


  /////////////////////// FOR CUSTOME CSS ONLY ///////////////////////////
  //   <PrimeReactProvider value={{ unstyled: true }}>
  // </PrimeReactProvider>

  const getFirstUrl = (items) => {
    for (let item of items) {
      if (item.url) return item.url;
      if (item.children) {
        const childUrl = getFirstUrl(item.children);
        if (childUrl) return childUrl;
      }
    }
    return null;
  };

  const defaultRoute = getFirstUrl(navigation.superItems) || "/dashboard";

  return (
    <div className="App">
      <AuthContextProvider>
        <PrimeReactProvider>
          <BrowserRouter>
            <Routes>
              {/* Default redirect to login */}
              <Route path="/" element={<Navigate to="/login" replace />} />

              {/* Private routes */}
              <Route element={<PrivateRouter />}>
                <Route element={<MainLayout />}>
                  {PrivateRoutes.length > 0 &&
                    PrivateRoutes.map((route, index) => {
                      return (
                        <Route
                          key={index}
                          path={route.path}
                          exact
                          element={
                            <React.Suspense fallback={<SuspenseLoader />}>
                              {route.element}
                            </React.Suspense>
                          }
                        />
                      );
                    })}
                </Route>
              </Route>

              {/* Login Route with redirect if already logged in */}
              <Route
                path="/login"
                element={
                  isAuthorised && isTokenValid() ? (
                    <Navigate to={defaultRoute} replace />
                  ) : (
                    <AuthLoginPage />
                  )
                }
              />

              {/* Handle invalid routes */}
              <Route
                path="*"
                element={
                  isAuthorised && isTokenValid() ? (
                    <Error404Page /> // 404 if logged in
                  ) : (
                    <Navigate to="/login" replace /> // Redirect to login if not logged in
                  )
                }
              />
            </Routes>
          </BrowserRouter>
        </PrimeReactProvider>
      </AuthContextProvider>
    </div>
  );
}




const mapStateToProps = (state) => {
  return {
    isAuthorised: state.isAuthorised,
    authToken: state.authToken,
  };
};

export default connect(mapStateToProps, null)(App);
